module.exports = __webpack_public_path__ + "static/fonts/Akrobat-ExtraBold.196f8f85.otf";